import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import { BuyerUpdateRequestBody } from "@/shared/api/buyer/types";
import { buyerUrl } from "@/shared/api/buyer/url";

export const buyerMutationApi = {
  // 바이어 수정 — PUT이지만 보낸 필드만 갱신하는 부분 수정이다.
  updateBuyer: async (buyerId: number, body: BuyerUpdateRequestBody) =>
    await axiosClient.put(buyerUrl.root(buyerId), toSnakeKeyObject(body)),
};
